import { call, put, takeLatest } from "redux-saga/effects";
import { presetsAPI } from "../api/api";
import { PresetsActionTypes } from "../actions/actionTypes";
import { API } from "../../../api/api";

function* getPresets(action) {
    try {
        const presets = yield call(() =>
            presetsAPI.getPresets({
                page: action.payload.page,
                top: action.payload.top,
                search: action.payload.search,
                subsidiaries: action.payload.subsidiaries,
                types: action.payload.types,
                prizeType: action.payload.prizeType,
                status: action.payload.status,
                certified: action.payload.certified
            })
        );

        yield put({
            type: PresetsActionTypes.GET_PRESETS_SUCCESS,
            payload: presets.data
        });
    } catch (e) {
        API.handleError(e.response, "Error fetching Presets");

        yield put({
            type: PresetsActionTypes.GET_PRESETS_FAIL,
            payload: e
        });
    }
}

export function* getPresetsWatcher() {
    yield takeLatest(PresetsActionTypes.GET_PRESETS, getPresets);
}

function* getPreset(action) {
    try {
        const preset = yield call(() =>
            presetsAPI.getPreset(action.payload.presetID)
        );

        yield put({
            type: PresetsActionTypes.GET_PRESET_SUCCESS,
            payload: preset.data
        });
    } catch (e) {
        API.handleError(e.response, "Error fetching Preset");

        yield put({
            type: PresetsActionTypes.GET_PRESET_FAIL,
            payload: e
        });
    }
}

export function* getPresetWatcher() {
    yield takeLatest(PresetsActionTypes.GET_PRESET, getPreset);
}
